import { combineEpics } from 'redux-observable';

import { loadStore } from './loadStore';
import { saveRequest } from './saveRequest';
import { updateComment } from './updateComment';

export default combineEpics(loadStore, saveRequest, updateComment);



// WEBPACK FOOTER //
// ./src/scenes/Store/services/epics/index.ts